import tw, { styled } from "twin.macro";

export const StyledFreeDeliveryText = styled.div`
  ${tw`flex items-center gap-xxs text-neutral-40`}
`;

export const StyledFreeDeliveryTooltip = styled.div`
  ${tw`max-w-[16rem] w-full`}
`;
